module.exports = __webpack_public_path__ + "static/esp-gourmet-98dacf8b73c1f84308de8ac716edc1ac.jpg";